import { Bell, CheckCircle2, FolderOpen, Repeat } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { habilitacionService } from '../../services/habilitacionService';
import './NotificationBell.css';

const NotificationBell = () => {
    const { user } = useAuth();
    const [notificaciones, setNotificaciones] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const fetchNotifications = async () => {
        if (!user) return;
        setLoading(true);
        try {
            const data = await habilitacionService.listarNotificaciones(user.id);
            setNotificaciones(data.data);
            setUnreadCount(data.unread);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        } finally {
            setLoading(false);
        }
    };

    // Cargar al inicio y al abrir
    useEffect(() => {
        fetchNotifications();
    }, [user]);

    const handleOpen = async () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            fetchNotifications();
            // Marcar como leídas visualmente después de un momento
            if (unreadCount > 0) {
                setTimeout(async () => {
                    await habilitacionService.marcarLeidas(user.id);
                    setUnreadCount(0);
                }, 2000);
            }
        }
    };

    const handleRefresh = (e) => {
        e.stopPropagation(); // Evitar cerrar el dropdown
        fetchNotifications();
    };

    return (
        <div className="notification-bell-container">
            <div className="bell-icon-wrapper" onClick={handleOpen}>
                <Bell size={24} />
                {unreadCount > 0 && <span className="badge badge-danger notification-badge">{unreadCount}</span>}
            </div>

            {isOpen && (
                <div className="notification-dropdown">
                    <div className="notification-header">
                        <span className="title">Notificaciones</span>
                        <button
                            className={`btn-refresh ${loading ? 'spinning' : ''}`}
                            onClick={handleRefresh}
                            title="Actualizar"
                        >
                            <Repeat size={18} />
                        </button>
                    </div>

                    <div className="notification-list">
                        {loading && notificaciones.length === 0 ? (
                            <div className="p-3 text-center text-muted">Cargando...</div>
                        ) : notificaciones.length === 0 ? (
                            <div className="empty-state">
                                <FolderOpen size={48} />
                                <p>No hay notificaciones</p>
                            </div>
                        ) : (
                            notificaciones.map(notif => (
                                <div key={notif.id} className={`notification-item ${!notif.leido ? 'unread' : ''}`}>
                                    <div className="notif-icon">
                                        <CheckCircle2 size={20} />
                                    </div>
                                    <div className="notif-content">
                                        <strong>{notif.titulo}</strong>
                                        <p>{notif.mensaje}</p>
                                        <small>{new Date(notif.fecha_creacion).toLocaleString()}</small>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificationBell;
